import React, { useState } from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import styles from './UpdateModal.module.scss'
import { Modal, Form, Input, Row, Col, message } from 'antd';

const FormItem = Form.Item;
const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
};

const UpdateName = ({
    closeMode,
    data,
}) => {
    console.log(data, 'data');
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form] = Form.useForm();

    const onSubmit = () => {
        form.validateFields().then((values) => {
            let submitDate = {
                contractCode: data.contractCode,
                contractName: values.contractName,
            };

            http('/?cmd=com.xqxc.api.pig.mis.biz.account.ContractService.updateContractName', submitDate, 'POST')
                .then(res => {
                    message.success('更新成功');
                    setConfirmLoading(false);
                    closeMode(true);
                })
                .catch((err = {}) => {
                    message.error(err.message);
                    setConfirmLoading(false);
                });
        }).catch(() => { });
    };

    return <Modal
        title='修改协议名称'
        centered
        destroyOnClose
        width={520}
        visible={true}
        maskClosable={false}
        confirmLoading={confirmLoading}
        onOk={onSubmit}
        onCancel={() => closeMode(false)}
    >
        <Form
            {...formLayout}
            autoComplete='off'
            name="create"
            scrollToFirstError
            initialValues={{
                contractName: data.contractName
            }}
            form={form}
        >

            <Row>
                <Col span={22}>
                    <FormItem
                        name="contractName"
                        label="协议名称"
                        colon={false}
                        rules={[{ required: true }]}
                    >
                        <Input
                            style={{ width: 270 }}
                            placeholder="请输入"
                            suffix={<FormItem
                                noStyle
                                shouldUpdate
                            >
                                {({ getFieldValue }) => {
                                    return getFieldValue('contractName') ? (
                                        <span key={getFieldValue('contractName')}>{getFieldValue('contractName').length}/15</span>
                                    ) : <span>0/15</span>;
                                }}
                            </FormItem>}
                            maxLength={15}
                        />
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </Modal>;
};

UpdateName.propTypes = {
    closeMode: PropTypes.func,//关闭操作
    data: PropTypes.object
};
export default UpdateName;